var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.875,1.75h-21A.881.881,0,0,1,0,.875.881.881,0,0,1,.875,0h21a.881.881,0,0,1,.875.875A.881.881,0,0,1,21.875,1.75Z",
    transform: "translate(2.625 23.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.348,1.719c-2.263-2.263-4.48-2.322-6.8,0L.135,3.131A.486.486,0,0,0,.018,3.6,9.483,9.483,0,0,0,6.47,10.049a.586.586,0,0,0,.14.023.467.467,0,0,0,.338-.14l1.4-1.412a4.822,4.822,0,0,0,1.715-3.372A4.8,4.8,0,0,0,8.348,1.719Z",
    transform: "translate(13.842 2.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M14.136,6.393c-.338-.163-.665-.327-.98-.513-.257-.152-.5-.315-.747-.49a7.045,7.045,0,0,1-.653-.5,1.423,1.423,0,0,1-.2-.175,9.867,9.867,0,0,1-1.2-1.213,1.422,1.422,0,0,1-.175-.21,6.786,6.786,0,0,1-.49-.642,6.406,6.406,0,0,1-.455-.688c-.187-.315-.35-.63-.513-.957-.163-.35-.292-.688-.408-1L.987,7.327a1.4,1.4,0,0,0-.327.642l-.63,4.468a2.392,2.392,0,0,0,.6,2.042,2.322,2.322,0,0,0,1.633.63,2.551,2.551,0,0,0,.42-.035l4.48-.63a1.3,1.3,0,0,0,.642-.327L15.127,6.79C14.8,6.673,14.486,6.545,14.136,6.393Z",
    transform: "translate(4.076 7.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.029a9195bee71318526e2848cf2d028e.svg";
export { ForwardRef as ReactComponent };